<template>
  <naj-box :title="local.agentForm.title">
    <attorney-form
      :form-model="formModel"
      :attorney-social-id="representativeSocialId"
      :related-social-id="formModel.unifiedNumber || formModel.commercialRegistrationNumber"
      :view-mode="viewMode"
    ></attorney-form>
  </naj-box>
</template>

<script>
import AttorneyForm from './attorney-form';

export default {
  inject: ['$validator'],
  components: { AttorneyForm },
  props: ['formModel', 'representativeSocialId', 'viewMode']
};
</script>
